<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<style scoped>
#page-virtualloby .con-ul-tabs {
  display: none;
}
.theme-thumbnail-tooltip {
  position: absolute;
  height: 267px;
  width: 450px;
  padding: 15px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
  z-index: 9999;
  background: #fff;
  border-radius: 7px;
  left: -14px;
  bottom: 162%;
  display: none;
}

.thumb-image-wrapper {
  height: 100%;
  width: 100%;
}
.theme-thumbnail-tooltip:after {
  left: 5%;
}
.vue-form-wizard .wizard-tab-content {padding: 0px 20px 10px !important;}
</style>
<template>
  <form-wizard
    color="rgba(var(--vs-primary), 1)"
    :title="null"
    :subtitle="null"
    finishButtonText="Submit"
    @on-complete="save_changes"
    layout="vertical"
  >
    <!-- tab 2 content -->
    <tab-content title="Main Panel" class="mb-5" icon="main-panel">
      <div class="vx-row">
        <div class="vx-col md:w-1/1 w-full mb-5">
          <div class="custom-head-wrap">'
            <h2 class="cms-custom-heading">Lobby Basics</h2>
          </div>
        </div>
        <div class="vx-col md:w-1/3 w-full">
          <label>Count Down Time (mins)</label>
          <div class="mt-2 lenghtinput">
            <vs-input-number
              class="inputx w-full mt-2"
              name="CountDownTime"
              v-model="data_local.CountDownTime"
              v-validate="'required'"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('CountDownTime')"
              >{{ errors.first("CountDownTime") }}</span
            >
          </div>
        </div>
        <div class="vx-col md:w-1/3 w-full" style="display: none">
          <!--Hide-->
          <label>Video Length(in Mins)</label>
          <div class="mt-2 lenghtinput">
            <vs-input-number
              name="VideoLength"
              v-model="data_local.VideoLength"
              v-validate="'required'"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('VideoLength')"
              >{{ errors.first("VideoLength") }}</span
            >
          </div>
        </div>
        <div class="vx-col md:w-1/3 w-full">
          <label>Upload Background Music</label>
          <!-- <vs-input class="inputx w-full mt-2"  name="MusicURL" v-model="data_local.MusicURL" v-validate="'required'"/> -->
          <div class="musicPath">
            <vs-input
              class="inputx w-full mt-2"
              name="MusicURL"
              v-model="data_local.MusicURL"
            />
            <label class="upload-files">
              <input type="file" accept="audio/*" @change="uploadMP3file" />
              <span>Upload</span>
            </label>
            <span class="text-danger text-sm" v-show="errors.has('MusicURL')">{{
              errors.first("MusicURL")
            }}</span>
          </div>
        </div>
        <div class="vx-col md:w-1/3 w-full mt-5" style="display: none">
          <!--Hide-->
          <label>Upload Video</label>
          <!-- <vs-input class="inputx w-full mt-2"  name="VideoURL" v-model="data_local.VideoURL" v-validate="'required'"/> -->
          <div class="musicPath">
            <vs-input
              class="inputx w-full mt-2"
              name="VideoURL"
              v-model="data_local.VideoURL"
              v-validate="'required'"
            />
            <span class="text-danger text-sm" v-show="errors.has('VideoURL')">{{
              errors.first("VideoURL")
            }}</span>
            <label class="upload-files">
              <input type="file" accept="video/*" @change="uploadVideofile" />
              <span>Upload</span>
            </label>
          </div>
        </div>
        <div class="vx-col md:w-1/3 w-full mt-0">
          <label>Lobby Page Background Music</label>
          <div class="w-full mt-2">
            <vs-radio
              class="ml-3"
              v-model="data_local.IsBackgroundMusic"
              vs-value="PlayAlways"
              name="IsBackgroundMusic"
              >Play Always</vs-radio
            >
            <vs-radio
              class="ml-3"
              v-model="data_local.IsBackgroundMusic"
              vs-value="PlayWithCountdown"
              name="IsBackgroundMusic"
              >Play With Countdown</vs-radio
            >
          </div>
        </div>
        <div class="vx-col md:w-1/3 w-full mt-5" style="display: none">
          <!--Hide-->
          <label>Hide Video Controls</label>
          <div class="w-full mt-3">
            <vs-radio
              v-model="data_local.IsVideoControl"
              vs-value="V_ConEnable"
              name="IsVideoControl"
              >Enable</vs-radio
            >
            <vs-radio
              class="ml-3"
              v-model="data_local.IsVideoControl"
              vs-value="V_ConDisable"
              name="IsVideoControl"
              >Disable</vs-radio
            >
          </div>
        </div>
        <div class="vx-col md:w-1/1 w-full mt-2">
          <vs-divider></vs-divider>
        </div>
        <!-- =========================== -->
        <div class="vx-col md:w-1/3 w-full mt-1" style="display: none">
          <!--Hide-->
          <!-- <label>Auto Redirect Microsite When Countdown Completed</label> -->
          <label>Auto Redirect</label>
          <div class="w-full mt-3">
            <vs-radio
              @change="showHideRedirect"
              v-model="data_local.AutoRedirectMicrositeWhenCountdownCompleted"
              vs-value="Enable"
              name="AutoRedirectMicrositeWhenCountdownCompleted"
              >Enable</vs-radio
            >
            <vs-radio
              @change="showHideRedirect"
              class="ml-3"
              v-model="data_local.AutoRedirectMicrositeWhenCountdownCompleted"
              vs-value="Disable"
              name="AutoRedirectMicrositeWhenCountdownCompleted"
              >Disable</vs-radio
            >
          </div>
        </div>
        <div class="vx-col md:w-1/3 w-full mt-1" style="display: none">
          <!--Hide-->
          <div v-if="AutoRedirectEnable">
            <label>Redirect to</label>
            <v-select
              class="mt-1"
              v-model="data_local.RedirectURL"
              label="URL"
              name="URL"
              :options="RedirectURL"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
            />
          </div>
        </div>
        <div class="vx-col md:w-1/3 w-full mt-1" style="display: none">
          <!--Hide-->
          <label>Show Bottom Menu</label>
          <div class="w-full mt-3">
            <vs-radio
              v-model="data_local.HideBottomMenu"
              vs-value="true"
              name="HideBottomMenu"
              >Show</vs-radio
            >
            <vs-radio
              class="ml-3"
              v-model="data_local.HideBottomMenu"
              vs-value="false"
              name="HideBottomMenu"
              >Hide</vs-radio
            >
          </div>
        </div>
        <div class="vx-col md:w-1/2 w-full mt-1">
          <label>Headline Text</label>
          <div class="w-full mt-0">
            <vs-input
              placeholder="Enter Headline Text here"
              class="inputx w-full mt-2"
              name="headlineText"
              v-model="data_local.headlineText"
            />
          </div>
        </div>
        <div class="vx-col md:w-1/2 w-full mt-1">
          <label>Hosted by</label>
          <div class="w-full mt-0">
            <vs-input
              placeholder="Enter Name here"
              class="inputx w-full mt-2"
              name="hostedBy"
              v-model="data_local.hostedBy"
            />
          </div>
        </div>
        <div class="vx-col md:w-1/2 w-full mt-1">
          <label>Join Button Text</label>
          <div class="w-full mt-0">
            <vs-input
              placeholder="Enter Display label here"
              class="inputx w-full mt-2"
              name="JoinButtonText"
              v-model="data_local.JoinButtonText"
              v-validate="'required'"
            />
          </div>
        </div>
        <div class="vx-col md:w-1/2 w-full mt-1">
          <label>Join Button Path (Eg: /sessions)</label>
          <div class="w-full mt-0">
            <vs-input
              placeholder="Enter Display label here"
              class="inputx w-full mt-2"
              name="JoinButtonUrl"
              v-model="data_local.JoinButtonUrl"
              v-validate="'required'"
            />
          </div>
        </div>
        <div class="vx-col md:w-1/2 mt-3 theme-select-flex-box">
          <label>Hamburger Bar Color(App)</label>
          <div class="mt-2 colorPicker picker-width">
            <vs-input
              type="color"
              v-model="data_local.HamburgerBarColor"
            />
          </div>
        </div>
        <div class="vx-col md:w-1/2 mt-3 theme-select-flex-box">
          <span class="lobbtTagText">Hide Event Name (App)</span>
          <vs-switch v-model="data_local.HideEventName">
          </vs-switch>
        </div>
        <div class="vx-col md:w-12/12 mt-3 theme-select-flex-box">
          <label class="mt-2">Hamburger Icon (App)</label>
          <div class="mt-2 bg-img-path mb-4">
            <img :src="data_local.HamburgerIcon" class="mr-8 rounded h-24 w-24" />
            <vs-input
              class="inputx w-full"
              v-model="data_local.HamburgerIcon"
            />
            <label class="upload-files">
              <input
                type="file"
                @change="iconUpload($event, 'HamburgerIcon')"
                accept="image/*"
              />
              <span>Upload</span>
            </label>
          </div>
        </div>

        <div class="vx-col md:w-1/1 w-full mt-5 mb-5">
          <div class="custom-head-wrap">
            <h2 class="cms-custom-heading">Color Theme</h2>
          </div>

        </div>
        <!-- =========================== -->
        <div class="vx-col md:w-1/1 w-full mt-1">
          <div class="vx-row color-theme">
            <div class="vx-col md:w-4/12 w-full mt-0">
              <label>Upload Lobby Background</label>
              <div class="mt-2 bg-img-path mb-4">
                <img :src="imgSrc" class="mr-8 rounded h-24 w-24" />
                <!--<vs-input class="inputx w-full" name="bgImagePath" v-model="data_local.coundownLobby.bgImagePath" v-validate="'required'"/>-->
                <vs-input
                  class="inputx w-full"
                  name="bgImagePath"
                  v-model="data_local.coundownLobby.bgImagePath"
                  v-validate="'required'"
                />
                <label class="upload-files">
                  <input
                    type="file"
                    ref="lobbyBgUpload_input"
                    @change="lobbyBgUpload($event, 'bgImagePath', 'imgSrc')"
                    accept="image/*"
                  />
                  <span>Upload</span>
                </label>
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('bgImagePath')"
                  >{{ errors.first("bgImagePath") }}</span
                >
              </div>

              <label class="mt-2">Upload Lobby Background (iPad)</label>
              <div class="mt-2 bg-img-path mb-4">
                <img :src="imgSrc2" class="mr-8 rounded h-24 w-24" />
                <vs-input
                  class="inputx w-full"
                  name="bgImageIpad"
                  v-model="data_local.coundownLobby.bgImageIpad"
                />
                <label class="upload-files">
                  <input
                    type="file"
                    @change="lobbyBgUpload($event, 'bgImageIpad', 'imgSrc2')"
                    accept="image/*"
                  />
                  <span>Upload</span>
                </label>
              </div>

              <label class="mt-2">Upload Lobby Background (App)</label>
              <div class="mt-2 bg-img-path mb-4">
                <img :src="imgSrc3" class="mr-8 rounded h-24 w-24" />
                <vs-input
                  class="inputx w-full"
                  name="bgImageApp"
                  v-model="data_local.coundownLobby.bgImageApp"
                />
                <label class="upload-files">
                  <input
                    type="file"
                    @change="lobbyBgUpload($event, 'bgImageApp', 'imgSrc3')"
                    accept="image/*"
                  />
                  <span>Upload</span>
                </label>
              </div>
            </div>

            <div class="vx-col md:w-4/12 w-full mt-0">
              <div class="theme-select-flex-box">
                <label>Header Text Color</label>
                <div class="mt-2 colorPicker picker-width">
                  <vs-input
                    type="color"
                    name="HeaderTextColor"
                    v-model="data_local.coundownLobby.HeaderTextColor"
                    v-validate="'required'"
                  />
                </div>
              </div>

              <div class="mt-3 theme-select-flex-box">
                <label>Join Button Background Color</label>
                <div class="mt-2 colorPicker picker-width">
                  <vs-input
                    type="color"
                    name="joinButtonBGColor"
                    v-model="data_local.coundownLobby.joinButtonBGColor"
                    v-validate="'required'"
                  />
                </div>
              </div>
            </div>
            <div class="vx-col md:w-4/12 w-full mt-0">
              <div class="theme-select-flex-box">
                <label>Join Button Shadow Color</label>
                <div class="mt-2 colorPicker picker-width">
                  <vs-input
                    type="color"
                    name="joinButtonShadowColor"
                    v-model="data_local.coundownLobby.joinButtonShadowColor"
                    v-validate="'required'"
                  />
                </div>
              </div>

              <div class="mt-3 theme-select-flex-box">
                <label>Join Button Font Color</label>
                <div class="mt-2 colorPicker picker-width">
                  <vs-input
                    type="color"
                    name="joinButtonFontColor"
                    v-model="data_local.coundownLobby.joinButtonFontColor"
                    v-validate="'required'"
                  />
                </div>
              </div>

              <div style="display: none">
                <label>Nav Color</label>
                <div class="mt-2 colorPicker picker-width">
                  <vs-input
                    type="color"
                    name="navcolor"
                    v-model="data_local.coundownLobby.navcolor"
                    v-validate="'required'"
                  />
                </div>
              </div>
              <div class="mt-3 theme-select-flex-box">
                <span class="lobbtTagText">Enable Additional Buttons</span>
                <!-- <span v-if="UseLobbyTag" class="lobbtTagText">Use Virtual lobby </span> -->
                <vs-switch v-model="SubButtons" @change="onSubButtonChange">
                  <span slot="On" vs-value="2" name="lobbySubButton">On</span>
                  <span slot="Off" vs-value="1" name="lobbySubButton">Off</span>
                </vs-switch>
              </div>
            </div>
          </div>
        </div>

        <div class="vx-col md:w-1/1 w-full mt-1"></div>

        <div v-if="SubButtons" class="vx-row">
          <div class="vx-col md:w-1/1 w-full my-4">
            <div class="custom-head-wrap">
                <h2 class="cms-custom-heading">Additional Buttons (Optional)</h2>
            </div>
          </div>
          <div class="vx-col md:w-1/3 w-full mt-1">
            <label>Button A Text</label>
            <div class="w-full mt-0">
              <vs-input
                placeholder="Enter Left Sub Display label here"
                class="inputx w-full mt-2"
                name="JoinButtonText"
                v-model="data_local.AdditionalButtons.LeftSubButtonLabel"
              />
            </div>
          </div>
          <div class="vx-col md:w-1/3 w-full mt-1">
            <label>Button B Text</label>
            <div class="w-full mt-0">
              <vs-input
                placeholder="Enter Middle Sub Display label here"
                class="inputx w-full mt-2"
                name="JoinButtonText"
                v-model="data_local.AdditionalButtons.MiddleSubButtonLabel"
              />
            </div>
          </div>
          <div class="vx-col md:w-1/3 w-full mt-1">
            <label>Button C Text</label>
            <div class="w-full mt-0">
              <vs-input
                placeholder="Enter Right Sub Display label here"
                class="inputx w-full mt-2"
                name="JoinButtonText"
                v-model="data_local.AdditionalButtons.RightSubButtonLabel"
              />
            </div>
          </div>
          <div class="vx-col md:w-1/3 w-full mt-1">
            <label>Set Path (Example: /roundtable)</label>
            <div class="w-full mt-0">
              <vs-input
                placeholder="Enter Left Sub Display URL here"
                class="inputx w-full mt-2"
                name="JoinButtonText"
                v-model="data_local.AdditionalButtons.LeftSubButtonURL"
              />
            </div>
          </div>
          <div class="vx-col md:w-1/3 w-full mt-1">
            <label>Set Path (Example: /attendee)</label>
            <div class="w-full mt-0">
              <vs-input
                placeholder="Enter Middle Sub Display URL here"
                class="inputx w-full mt-2"
                name="JoinButtonText"
                v-model="data_local.AdditionalButtons.MiddleSubButtonURL"
              />
            </div>
          </div>
          <div class="vx-col md:w-1/3 w-full mt-1">
            <label>Set Path (Example: /sponsor)</label>
            <div class="w-full mt-0">
              <vs-input
                placeholder="Enter Right Sub Display URL here"
                class="inputx w-full mt-2"
                name="JoinButtonText"
                v-model="data_local.AdditionalButtons.RightSubButtonURL"
              />
            </div>
          </div>
        </div>
        <div class="vx-col md:w-1/1 w-full mt-1">
          <vs-divider></vs-divider>
        </div>
        <!-- =========================== -->

        <div class="vx-col md:w-1/2 w-full mt-2">
          <!-- <label>Show Photo Scroll(Left)</label>-->
          <div class="image-scroll-wrapper">
            <label class="option-wrap">Use Image Scroller (Left Panel)</label>
            <div class="theme-info-area">
              <feather-icon class="ml-2 info-ico-i" icon="InfoIcon" title />
              <div class="theme-thumbnail-tooltip">
                <div class="thumb-image-wrapper">
                  <img
                    src="../../assets/images/default-theme-left-border.jpg"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="w-full mt-3">
            <vs-radio
              @change="showHideLeftScroll"
              v-model="data_local.HidePhotoScrollLeft"
              vs-value="ShowPhotoScrollLeftShow"
              name="HidePhotoScrollLeft"
              >Show</vs-radio
            >
            <vs-radio
              @change="showHideLeftScroll"
              v-model="data_local.HidePhotoScrollLeft"
              vs-value="ShowPhotoScrollLeftHide"
              name="HidePhotoScrollLeft"
              class="ml-3"
              >Hide</vs-radio
            >
          </div>
        </div>
        <div class="vx-col md:w-1/2 w-full mt-2">
          <!-- <label>Show Photo Scroll(Right)</label>-->
          <div class="image-scroll-wrapper">
            <label class="option-wrap">Use Image Scroller (Right Panel)</label>
            <div class="theme-info-area">
              <feather-icon class="ml-2 info-ico-i" icon="InfoIcon" title />
              <div class="theme-thumbnail-tooltip-left">
                <div class="thumb-image-wrapper">
                  <img
                    src="../../assets/images/default-theme-right-border.jpg"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="w-full mt-3">
            <vs-radio
              @change="showHideRightScroll"
              v-model="data_local.HidePhotoScrollRight"
              vs-value="ShowPhotoScrollRightShow"
              name="HidePhotoScrollRight"
              >Show</vs-radio
            >
            <vs-radio
              @change="showHideRightScroll"
              class="ml-3"
              v-model="data_local.HidePhotoScrollRight"
              vs-value="ShowPhotoScrollRightHide"
              name="HidePhotoScrollRight"
              >Hide</vs-radio
            >
          </div>
        </div>
      </div>
    </tab-content>
    <tab-content
      title="Left Panel"
      class="mb-5"
      icon="left-panel"
      v-if="ShowHideLeftEnable"
    >
      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full mt-4">
          <label>Border Color</label>
          <div class="mt-2 colorPicker">
            <vs-input
              type="color"
              name="sponsorBorderColor"
              v-model="data_local.coundownLobby.sponsorBorderColor"
              v-validate="'required'"
            />
          </div>
        </div>
        <div class="vx-col md:w-1/2 w-full mt-4">
          <label>Background Color</label>
          <div class="mt-2 colorPicker">
            <vs-input
              type="color"
              name="sponsorBGColor"
              v-model="data_local.coundownLobby.sponsorBGColor"
              v-validate="'required'"
            />
          </div>
        </div>
        <div class="vx-col md:w-1/2 w-full mt-4" style="display: none">
          <div v-if="ShowHideLeftEnable">
            <label>Photo Scroll</label>
            <v-select
              class="mt-3"
              v-model="data_local.PhotoScrollerLeft"
              label="photoDirectory"
              :options="photoWallList"
              name="PhotoScrollerLeft"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
            />
            <!-- <v-select class="mt-3" v-model="data_local.PhotoScrollerLeft" label="PhotoName" :options="PhotoScrollerLeft" name="PhotoName" :dir="$vs.rtl ? 'rtl' : 'ltr'" />  -->
            <span
              class="text-danger text-sm"
              v-show="errors.has('PhotoScrollerLeft')"
              >{{ errors.first("PhotoScrollerLeft") }}</span
            >
          </div>
        </div>
        <div class="vx-col md:w-1/2 w-full mt-4">
          <div>
            <label>Photo Scroll Heading</label>
            <vs-input
              class="inputx w-full mt-2"
              v-model="data_local.PhotoScrollLeftHeading"
            />
          </div>
        </div>
        <div class="vx-col md:w-1/2 w-full mt-4">
          <div>
            <label>Photo Scroll Sub-Heading</label>
            <vs-input
              class="inputx w-full mt-2"
              v-model="data_local.PhotoScrollLeftSubHeading"
            />
          </div>
        </div>
        <div class="vx-col md:w-1/2 w-full mt-4">
          <div>
            <div class="image-scroll-wrapper">
              <label>Select Photo Album(s)</label>
              <div class="theme-info-area">
                <feather-icon class="ml-2 info-ico-i" icon="InfoIcon" title />
                <div class="theme-thumbnail-tooltip">
                  <div class="thumb-image-wrapper">
                    <img
                      src="../../assets/images/default-theme-left-border.jpg"
                    />
                  </div>
                </div>
              </div>
            </div>
            <v-select
              multiple
              class="track-select"
              name="photoDirectory"
              label="photoDirectory"
              v-model="data_local.LeftPanelPhotoWallAlbum"
              :options="LeftPhotoWallAlbumList"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
            />
          </div>
        </div>

        <div class="vx-col md:w-1/2 w-full mt-4">
          <div class="lenghth-wrap">
            <label>Photo Transition (secs)</label>
            <div class="lenghtinput">
              <vs-input-number
                min="2"
                class="inputx w-full mt-2"
                name="CountDownTime"
                v-model="data_local.LeftPanelImageTransitionDelay"
                v-validate="'required'"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('CountDownTime')"
                >{{ errors.first("CountDownTime") }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </tab-content>
    <tab-content
      title="Right Panel"
      class="mb-5"
      icon="right-panel"
      v-if="ShowHideRightEnable"
    >
      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full mt-4">
          <label>Border Color</label>
          <div class="mt-2 colorPicker">
            <vs-input
              type="color"
              name="photoWallBorderColor"
              v-model="data_local.coundownLobby.photoWallBorderColor"
              v-validate="'required'"
            />
          </div>
        </div>
        <div class="vx-col md:w-1/2 w-full mt-4">
          <label>Background Color</label>
          <div class="mt-2 colorPicker">
            <vs-input
              type="color"
              name="photoWallBGColor"
              v-model="data_local.coundownLobby.photoWallBGColor"
              v-validate="'required'"
            />
          </div>
        </div>

        <div class="vx-col md:w-1/2 w-full mt-4" style="display: none">
          <div>
            <label>Photo Scroll</label>
            <v-select
              class="mt-3"
              v-model="data_local.PhotoScrollerRight"
              label="photoDirectory"
              name="PhotoScrollerRight"
              :options="photoWallList"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
            />
            <!-- <v-select class="mt-3"  v-model="data_local.PhotoScrollerRight" label="PhotoName" name="PhotoName" :options="PhotoScrollerLeft" :dir="$vs.rtl ? 'rtl' : 'ltr'" />  -->
            <span
              class="text-danger text-sm"
              v-show="errors.has('PhotoScrollerRight')"
              >{{ errors.first("PhotoScrollerRight") }}</span
            >
          </div>
        </div>
        <div class="vx-col md:w-1/2 w-full mt-4">
          <div>
            <label>Photo Scroll Heading</label>
            <vs-input
              class="inputx w-full mt-2"
              v-model="data_local.PhotoScrollRightHeading"
            />
          </div>
        </div>
        <div class="vx-col md:w-1/2 w-full mt-4">
          <div>
            <label>Photo Scroll Sub-Heading</label>
            <vs-input
              class="inputx w-full mt-2"
              v-model="data_local.PhotoScrollRightSubHeading"
            />
          </div>
        </div>
        <div class="vx-col md:w-1/2 w-full mt-4">
          <div>
            <div class="image-scroll-wrapper">
              <label>Select Photo Album(s)</label>
              <div class="theme-info-area">
                <feather-icon class="ml-2 info-ico-i" icon="InfoIcon" title />
                <div class="theme-thumbnail-tooltip">
                  <div class="thumb-image-wrapper">
                    <img
                      src="../../assets/images/default-theme-right-border.jpg"
                    />
                  </div>
                </div>
              </div>
            </div>
            <v-select
              multiple
              class="track-select"
              name="photoDirectory"
              label="photoDirectory"
              v-model="data_local.RightPanelPhotoWallAlbum"
              :options="RightPhotoWallAlbumList"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
            />
          </div>
        </div>
        <div class="vx-col md:w-1/2 w-full mt-4">
          <div class="lenghth-wrap">
            <label>Photo Transition (secs)</label>
            <div class="lenghtinput">
              <vs-input-number
                min="2"
                class="inputx w-full mt-2"
                name="CountDownTime"
                v-model="data_local.RightPanelImageTransitionDelay"
                v-validate="'required'"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('CountDownTime')"
                >{{ errors.first("CountDownTime") }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </tab-content>

    <!-- tab  content -->
  </form-wizard>

  <!-- <div id="user-edit-tab-info" class="mt-0">
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="save_changes" :disabled="!validateForm">Save Changes</vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Reset</vs-button>
        </div>
      </div>
    </div>
  </div>-->
</template>

<script>
import vSelect from "vue-select";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

import ls from "@/common/localStorage";
import modulePhotoWall from "@/store/photowall-management/modulePhotowallManagement.js";
import moduleEventManagement from "@/store/event-management/moduleEventManagement.js";

import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
var cn = ls.getSessionEventCollectionName();
var vm;
export default {
  components: {
    vSelect,
    quillEditor,
    "v-select": vSelect,
    flatPickr,
    FormWizard,
    TabContent,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      LeftPhotoWallAlbumList: [],
      RightPhotoWallAlbumList: [],
      LobbyType: false,
      data_local: JSON.parse(JSON.stringify(this.data)),
      imgSrc: this.data.coundownLobby.bgImagePath,
      imgSrc2: this.data.coundownLobby.bgImageIpad,
      imgSrc3: this.data.coundownLobby.bgImageApp,
      photoWallList: [],
      SubButtons: this.data.EnableSubButtons,
      AutoRedirectEnable:
        this.data.AutoRedirectMicrositeWhenCountdownCompleted == "Enable"
          ? true
          : false,
      AutoRedirectDisable:
        this.data.AutoRedirectMicrositeWhenCountdownCompleted == "Disable"
          ? true
          : false,

      ShowHideLeftEnable:
        this.data.HidePhotoScrollLeft == "ShowPhotoScrollLeftShow"
          ? true
          : false,
      ShowHideLeftDisable:
        this.data.HidePhotoScrollLeft == "ShowPhotoScrollLeftHide"
          ? true
          : false,

      ShowHideRightEnable:
        this.data.HidePhotoScrollRight == "ShowPhotoScrollRightShow"
          ? true
          : false,
      ShowHideRightDisable:
        this.data.HidePhotoScrollRight == "ShowPhotoScrollRightHide"
          ? true
          : false,

      PhotoScrollerLeft: [
        { PhotoName: "Photo Scroller Option 1" },
        { PhotoName: "Photo Scroller Option 2" },
        { PhotoName: "Photo Scroller Option 3" },
      ],
      PhotoScrollerRight: [
        { PhotoName: "Photo Scroller Option 1" },
        { PhotoName: "Photo Scroller Option 2" },
        { PhotoName: "Photo Scroller Option 3" },
      ],
      RedirectURL: [{ URL: "www.webspiders.com" }, { URL: "www.e2m.live" }],
      mp3File: "",
    };
  },
  computed: {
    status_local: {
      get() {
        return {
          label: this.capitalize(this.data_local.status),
          value: this.data_local.status,
        };
      },
      set(obj) {
        this.data_local.status = obj.value;
      },
    },
    role_local: {
      get() {
        return {
          label: this.capitalize(this.data_local.role),
          value: this.data_local.role,
        };
      },
      set(obj) {
        this.data_local.role = obj.value;
      },
    },
    validateForm() {
      return !this.errors.any();
    },
  },
  methods: {
    fetch_photowallAlbum() {
      this.$store
        .dispatch("photowallManagement/fetchPhotowallAlbum") //fetchphotowallAlbum
        .then((res) => {
          this.LeftPhotoWallAlbumList = res;
          this.RightPhotoWallAlbumList = res;
          console.log(res);
        });
    },
    onSubButtonChange: function (context, LobbyType) {
      //debugger
      //  var LobbyType = 1;
      if (this.SubButtons) {
        // LobbyType = 2;
        //  vm.activeTab = 1;
        //For Show hide
        vm.SubButtons = false;
      } else {
        //LobbyType = 1;
        // vm.activeTab = 0;
        //For Show hide
        vm.SubButtons = true;
      }
      this.$store
        .dispatch(
          "virtuallobbyManagement/updateVirtualLobbySubButtonStatus",
          vm.SubButtons
        )
        .then((res) => {
          alert(res.message);
          if (res.status == 200) {
            // change Tab
          }
        })
        .catch((err) => {});
    },
    capitalize(str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length);
    },
    showHideRedirect() {
      if (this.AutoRedirectEnable) {
        this.AutoRedirectEnable = false;
        this.AutoRedirectDisable = true;
      } else {
        this.AutoRedirectEnable = true;
        this.AutoRedirectDisable = false;
      }
    },
    showHideLeftScroll() {
      if (this.ShowHideLeftEnable) {
        this.ShowHideLeftEnable = false;
        this.ShowHideLeftDisable = true;
      } else {
        this.ShowHideLeftEnable = true;
        this.ShowHideLeftDisable = false;
      }
    },
    showHideRightScroll() {
      if (this.ShowHideRightEnable) {
        this.ShowHideRightEnable = false;
        this.ShowHideRightDisable = true;
      } else {
        this.ShowHideRightEnable = true;
        this.ShowHideRightDisable = false;
      }
    },
    save_changes() {
      if (!this.validateForm) return;
      this.$vs.loading();
      //this.data_local.coundownLobby.bgImagePath = this.imgSrc
      this.$store
        .dispatch("virtuallobbyManagement/addVirtuallobby", {
          data: this.data_local,
        })
        .then((res) => {
          if (res.status == 200) {
            location.reload();
            this.$vs.loading.close();
          }
        })
        .catch((err) => {});
      //}
    },
    reset_data() {
      this.data_local = JSON.parse(JSON.stringify(this.data));
      this.imgSrc = this.data.ProfilePictureURL;
    },

    getPhotowall() {
      this.$store
        .dispatch("photowallManagement/fetchPhotowalls")
        .then((res) => {
          //this.attendessList = res;
          //console.log(res);
          for (let i = 0; i < res.length; i++) {
            console.log(res[i].photoDirectory);

            this.photoWallList.push({
              photoDirectory: res[i].photoDirectory,
              photourl: res[i].photoUrls,
            });
          }
        });
    },

    uploadMP3file(input) {
      // You can update avatar Here
      if (input.target.files && input.target.files[0]) {
        const musicfile = input.target.files[0];
        const metadata = { contentType: musicfile.type };
        const validFileTypes = ["audio/mp3", "audio/mpeg"];
        if (!validFileTypes.includes(musicfile.type)) {
          alert("Only mp3 file allowed.");
          return false;
        }
        if (musicfile.size > 15728640) {
          //max 15 MB file Size
          alert("File too big (> 15MB)");
          return false;
        }
        this.data_local.musicfile = musicfile;
        const reader = new FileReader();
        reader.onload = (e) => {
          //this.mp3File = e.target.result
        };
        console.log(musicfile);
        vm.data_local.MusicURL = musicfile.name;
        reader.readAsDataURL(input.target.files[0]);
      }
    },

    lobbyBgUpload(input, fieldName, fieldsrc) {
      // You can update avatar Here
      if (input.target.files && input.target.files[0]) {
        const bgImgfile = input.target.files[0];
        const metadata = { contentType: bgImgfile.type };
        const validImageTypes = ["image/jpeg", "image/png"];
        if (!validImageTypes.includes(bgImgfile.type)) {
          alert("Only gif,jpeg & png file allowed.");
          return false;
        }
        let FileSize = bgImgfile.size / 1024 / 1024;
        if (FileSize > 1) {
          alert("Uploaded file size exceeds 1 MB");
          return false;
        }
        //this.data_local[fieldName] = bgImgfile;
        const reader = new FileReader();
        reader.onload = (e) => {
          this.uploadFile(bgImgfile, fieldName, fieldsrc);
          this[fieldsrc] = e.target.result;
        };

        reader.readAsDataURL(input.target.files[0]);
      }
    },
    uploadFile(file, fieldName, fieldsrc) {
      this.$vs.loading();
      this.$store
        .dispatch("eventManagement/uploadImage", {
          file: file,
          path: cn + "/Lobby/",
        })
        .then((res) => {
          this.$vs.loading.close();
          this.data_local.coundownLobby[fieldName] = res;
        })
        .catch((err) => {
          //console.error(err)
          this.$vs.loading.close();
        });
    },
    iconUpload(input, fieldName){
      if (input.target.files && input.target.files[0]) {
        const bgImgfile = input.target.files[0];
        const metadata = { contentType: bgImgfile.type };
        const validImageTypes = ["image/jpeg", "image/png"];
        if (!validImageTypes.includes(bgImgfile.type)) {
          alert("Only gif,jpeg & png file allowed.");
          return false;
        }
        let FileSize = bgImgfile.size / 1024 / 1024;
        if (FileSize > 1) {
          alert("Uploaded file size exceeds 1 MB");
          return false;
        }
        //this.data_local[fieldName] = bgImgfile;
        const reader = new FileReader();
        reader.onload = (e) => {
          this.uploadIconFile(bgImgfile, fieldName);
        };

        reader.readAsDataURL(input.target.files[0]);
      }
    },
    uploadIconFile(file, fieldName) {
      this.$vs.loading();
      this.$store
        .dispatch("eventManagement/uploadImage", {
          file: file,
          path: cn + "/Lobby/",
        })
        .then((res) => {
          this.$vs.loading.close();
          this.data_local[fieldName] = res;
        })
        .catch((err) => {
          //console.error(err)
          this.$vs.loading.close();
        });
    },
    uploadVideofile(input) {
      // You can update avatar Here
      if (input.target.files && input.target.files[0]) {
        const videofile = input.target.files[0];
        const metadata = { contentType: videofile.type };
        // const validFileTypes = ['video/MPEG4']
        // if (!validFileTypes.includes(videofile.type)) {
        //   alert('Only mp3 file allowed.')
        //   return false
        // }
        if (videofile.size > 645857280) {
          //max 30 MB file Size
          alert("File too big (> 30MB)");
          return false;
        }
        this.data_local.videofile = videofile;
        const reader = new FileReader();
        reader.onload = (e) => {
          //this.mp3File = e.target.result
        };
        console.log(videofile);
        vm.data_local.VideoURL = videofile.name;
        reader.readAsDataURL(input.target.files[0]);
      }
    },
    fetchBrandingJson(isHostEmpty) {
      if (isHostEmpty) {
        this.$store
          .dispatch("eventManagement/fetchBrandingJson")
          .then((res) => {
            //let obj = JSON.parse(res)
            //console.log(res.eventLogo)
            //console.log(res.eventLogo["960x192"])
            if (res) {
              if (isHostEmpty) {
                if (res.HostInfo != undefined) {
                  if (res.HostInfo.Name != undefined) {
                    vm.data_local.hostedBy = res.HostInfo.Name;
                  }
                }
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
  },
  mounted() {
    vm = this;
    if (vm.data_local.hostedBy == undefined || vm.data_local.hostedBy == "") {
      //vm.fetchBrandingJson(true);
    }
  },
  created() {
    if (!modulePhotoWall.isRegistered) {
      this.$store.registerModule("photowallManagement", modulePhotoWall);
      modulePhotoWall.isRegistered = true;
    }
    this.getPhotowall();

    if (!moduleEventManagement.isRegistered) {
      this.$store.registerModule("eventManagement", moduleEventManagement);
      moduleEventManagement.isRegistered = true;
    }
    this.fetch_photowallAlbum();
  },
};
</script>
